import { render, staticRenderFns } from "./LabelPreview.vue?vue&type=template&id=ddaa062e&scoped=true"
import script from "./LabelPreview.vue?vue&type=script&lang=js"
export * from "./LabelPreview.vue?vue&type=script&lang=js"
import style0 from "./LabelPreview.vue?vue&type=style&index=0&id=ddaa062e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddaa062e",
  null
  
)

export default component.exports